import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import '../UtilityView.css';
import './NcDmv.css';

class NcDmvDetailedRenewal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { renewal, } = this.props;
    const options = {};
    options.headerFormatter = object => _.startCase(object.header);

    const residentialAddress = JSON.parse(renewal.residentialAddress === '' ? '{}' : renewal.residentialAddress);
    const mailingAddress = JSON.parse(renewal.mailingAddress === '' ? '{}' : renewal.mailingAddress);
    const situsAddress = JSON.parse(renewal.situsAddress === '' ? '{}' : renewal.situsAddress);
    const refunds = typeof renewal.refunds === 'string' ? ObjectUtils.formatStringAsJSONArray(renewal.refunds) : renewal.refunds;
    const refundsModel = Grid.toModelFromList(refunds, options);
    const propertyTaxFees = ObjectUtils.formatStringAsJSONArray(renewal.propertyTaxFees);
    const propertyTaxFeesModel = Grid.toModelFromList(propertyTaxFees, options);
    const penaltyFees = ObjectUtils.formatStringAsJSONArray(renewal.penaltyFees);
    const penaltyFeesModel = Grid.toModelFromList(penaltyFees, options);
    const registrationFees = ObjectUtils.formatStringAsJSONArray(renewal.registrationFees);
    const registrationFeesModel = Grid.toModelFromList(registrationFees, options);

    const renewalItems = VerticalLabelList.toList({
      'Customer Email': renewal.customerEmail,
      'Due Date': moment(renewal.dueDate).utc().format(),
      'Grace Period Days': renewal.gracePeriodDays,
      'Transaction Time': moment(renewal.transactionTimestamp).utc().format(),
      'Transaction Id': renewal.transactionId,
      'V3 Transaction': renewal.v3Transaction,
      'V3 Transaction Line Item Id': renewal.lineItemId,
      'Service Item': renewal.serviceType,
      'Payment Account Type': renewal.paymentAccountType,
      'Payment Failure': renewal.paymentFailure,
      'Persisted to NC': renewal.persistedToNc,
      'Eligibility Failure': renewal.eligibilityFailure,
      'Fee Change Failure': renewal.feeChangeFailure,
      'Property Tax Amount': renewal.propertyTaxAmount.value,
    });

    const vehicleItems = VerticalLabelList.toList({
      'Vehicle Body Style': renewal.vehicleBodyStyle,
      Make: renewal.make,
      Model: renewal.model,
      Year: renewal.year,
      'Plate Number': renewal.plateNumber,
      'Plate Background': renewal.plateBackground,
      'Fuel Type': renewal.vehicleFuelType,
      'Title Last Five': renewal.titleNumberLastFive,
      VIN: renewal.vin,
    });

    const address = input => VerticalLabelList.toList({
      'Street 1': input.street1,
      'Street 2': input.street2,
      City: input.city,
      County: input.county,
      State: input.state,
      Zip: input.zip,
    });

    return (
      <div>
        <div className="column-2" style={{ marginTop: '50px', }}>
          <FieldSet title="Renewal Summary">
            <VerticalLabelList
              items={renewalItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Vehicle Information">
            <VerticalLabelList
              items={vehicleItems}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Property Tax Fees" style={{ maxHeight: '200px', }}>
            <Grid
              headers={propertyTaxFeesModel.headers}
              rows={propertyTaxFeesModel.format(propertyTaxFees)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Penalty Fees" style={{ maxHeight: '200px', }}>
            <Grid
              headers={penaltyFeesModel.headers}
              rows={penaltyFeesModel.format(penaltyFees)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Registration Fees" style={{ maxHeight: '200px', }}>
            <Grid
              headers={registrationFeesModel.headers}
              rows={registrationFeesModel.format(registrationFees)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Refunds" style={{ maxHeight: '200px', }}>
            <Grid
              headers={refundsModel.headers}
              rows={refundsModel.format(refunds)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Situs Address">
            <VerticalLabelList
              items={address(situsAddress)}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Residential Address">
            <VerticalLabelList
              items={address(residentialAddress)}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Mailing Address">
            <VerticalLabelList
              items={address(mailingAddress)}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

NcDmvDetailedRenewal.propTypes = {
  renewal: PropTypes.instanceOf(Object).isRequired,
};

export default NcDmvDetailedRenewal;
